import { render, staticRenderFns } from "./adminregister.vue?vue&type=template&id=3d1b1447&scoped=true&"
import script from "./adminregister.vue?vue&type=script&lang=js&"
export * from "./adminregister.vue?vue&type=script&lang=js&"
import style0 from "./adminregister.vue?vue&type=style&index=0&id=3d1b1447&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1b1447",
  null
  
)

export default component.exports